import { WifiOff, Server, AlertCircle, ShieldOff } from 'lucide-react';
import { ApiErrorConfig } from './types';

const apiErrorConfigs: Record<string, ApiErrorConfig> = {
  ApiNetworkError: {
    icon: <WifiOff className="h-10 w-10 text-red-600" />,
    title: 'Network Connection Failed',
    getDescription: () =>
      'Unable to connect to the server. Please check your internet connection and try again.',
  },

  ApiAuthUnauthorized: {
    icon: <ShieldOff className="h-10 w-10 text-red-600" />,
    title: 'Authentication Error',
    getDescription: () =>
      'Your session has expired. Please log in again to continue.',
  },

  ApiServerError: {
    icon: <Server className="h-10 w-10 text-red-600" />,
    title: 'Server Error',
    getDescription: error =>
      error.message ||
      'The server encountered an error while processing your request.',
  },

  ApiClientError: {
    icon: <AlertCircle className="h-10 w-10 text-red-600" />,
    title: 'Request Failed',
    getDescription: error =>
      error.message || 'The request could not be processed. Please try again.',
  },

  default: {
    icon: <AlertCircle className="h-10 w-10 text-red-600" />,
    title: 'Something Went Wrong',
    getDescription: error =>
      error.message ||
      'An unexpected error occurred while processing your request.',
  },
};

export const getApiErrorConfig = (errorType: string): ApiErrorConfig => {
  return apiErrorConfigs[errorType] || apiErrorConfigs.default;
};

export { apiErrorConfigs };
